<template>
    <div class="animated fadeIn efficiency">
        <div v-bind:class="{ disabledbutton: loadingRemnants }">
            <filters :scope="filtersScope">
            </filters>
        </div>
        <modal effect="fade/zoom" small title="" v-model="confirmModal">
            <div class="modal-header" slot="modal-header">
                <div style="font-size: 1.5em;text-align: center;">{{$t('statistic.expiration_date')}}</div>
            </div>
            <div style="text-align: center;">
                <div class="card card-default filters card-modal">
                    <div class="card-modal">
                        <div class="error" v-if="errorsByOrder.length">
                            <b>Пожалуйста исправьте указанные ошибки:</b>
                            <ul>
                                <li :key="index" v-for="(error, index) in errorsByOrder">{{ error }}</li>
                            </ul>
                        </div>
                        <div class="row date-filter">
                            <div class="col-12">
                                <DatePicker :language="Storage.language" :placeholder="$t('statistic.expiration_date')" class="datepicker" format="yyyy-MM-dd" v-model="expiration"></DatePicker>
                            </div>
                            <div class="col-12 pad-top">
                                <input :placeholder="$t('statistic.customs')" class="form-control input" name="customs" type="text" v-model="customs">
                            </div>
                            <div class="col-12 pad-top">
                                <input :placeholder="$t('statistic.logistic')" class="form-control input" name="customs" type="text" v-model="logistics">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 filter-buttons">
                                <button @click="addExpiration"
                                        class="btn btn-primary btn-lg">
                                    {{$t('verbs.save')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer" slot="modal-footer">
            </div>
        </modal>

        <ProductTabs></ProductTabs>
        <RemnantsOrders :rowRemnants="rowRemnants" :loading="loadingRemnants" @changeVal="changeValRemnants" ></RemnantsOrders>
        <div class="card card-default filters" style="margin-top: 20px;">
            <div class="card-block">
                <div class="row justify-content-between">
                    <div class="col-md-3">
                        <button :disabled="isLoad"
                                @click="clickAdd()"
                                class="btn btn-primary btn-lg">
                            <i class="fa fa-archive"></i> {{ $t('verbs.add_product') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-default filters" v-show="isBlock">
            <div class="card-block">
                <form
                        @submit="checkForm"
                >
                    <div class="error" v-if="errors.length">
                        <b>Пожалуйста исправьте указанные ошибки:</b>
                        <ul>
                            <li :key="index" v-for="(error, index) in errors">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="row justify-content-between" v-if="Storage.selectedCountry.id === -1">
                        <div class="col-md-3">
                            <div class="row pad-top">
                                <div class="col-12">
                                    <select class="form-controls input" name="status" v-model="form.country" @change="getGoodsAll">
                                        <option disabled  selected value="dis">{{ $t('statistic.country') }}</option>
                                        <option v-for="c in Storage.countries" :value="c.id" v-if="c.id !== -1">{{c.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.ordered')" class="form-control input" name="orders_count" type="number" v-model="form.orders_count">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.price')" class="form-control input" name="price" type="text" v-model="form.price">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.provider')" class="form-control input" name="provider" type="text" v-model="form.provider">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <DatePicker :language="Storage.language" :placeholder="$t('statistic.time')" class="datepicker" format="yyyy-MM-dd" name="delivery_time"
                                                v-model="form.delivery_time">
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <select class="form-controls input" name="status" v-model="form.status" >
                                        <option disabled  selected value="dis">{{ $t('statistic.status') }}</option>
                                        <option value="0">Заказан</option>
                                        <option value="1">Отгружен</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.comment')" class="form-control input" name="comment" type="text" v-model="form.comment">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row pad-top">
                                <div class="col-12">
                                    <input @change="handleFilesUpload($event.target.name, $event.target.files)"  class="form-control input files" ref="file"  type="file">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <MultiSelect :clear-on-select="false" :close-on-select="false" :hide-selected="false" :multiple="false" :options="storageGoodsAll"
                                                 :placeholder="$t('statistic.products')" :preserve-search="true" :searchable="true" label="name"
                                                 name="product" ref="multiselect" track-by="name" v-model="form.product">
                                        <template scope="props" slot="option">
                                            <div class="option__desc">
                                                        <span class="option__title">
                                                        {{ props.option.name }} <b v-if="Storage.developMode">({{ props.option.alias }})</b>
                                                        </span>
                                            </div>
                                        </template>
                                    </MultiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-primary float-right" type="submit">Отправить</button>
                            <!--<input class="float-right" type="submit" value="Отправить" />-->
                        </div>
                    </div>
                    <div class="row justify-content-between" v-else>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <MultiSelect :clear-on-select="false" :close-on-select="false" :hide-selected="false" :multiple="false" :options="Storage.goods"
                                                 :placeholder="$t('statistic.products')" :preserve-search="true" :searchable="true" label="name"
                                                 name="product" ref="multiselect" track-by="name" v-model="form.product">
                                        <template scope="props" slot="option">
                                            <div class="option__desc">
                                                        <span class="option__title">
                                                        {{ props.option.name }} <b v-if="Storage.developMode">({{ props.option.alias }})</b>
                                                        </span>
                                            </div>
                                        </template>
                                    </MultiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.ordered')" class="form-control input" name="orders_count" type="number" v-model="form.orders_count">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.price')" class="form-control input" name="price" type="text" v-model="form.price">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.provider')" class="form-control input" name="provider" type="text" v-model="form.provider">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <DatePicker :language="Storage.language" :placeholder="$t('statistic.time')" class="datepicker" format="yyyy-MM-dd" name="delivery_time"
                                                v-model="form.delivery_time">
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <select class="form-controls input" name="status" v-model="form.status" >
                                        <option disabled  selected value="dis">{{ $t('statistic.status') }}</option>
                                        <option value="0">Заказан</option>
                                        <option value="1">Отгружен</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row date-filter pad-top">
                                <div class="col-12">
                                    <input :placeholder="$t('statistic.comment')" class="form-control input" name="comment" type="text" v-model="form.comment">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="row pad-top">
                                <div class="col-12">
                                    <input @change="handleFilesUpload($event.target.name, $event.target.files)"  class="form-control input files" ref="file"  type="file">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 pad-top">
                            <button class="btn btn-primary float-right" type="submit">Отправить</button>
                            <!--<input class="float-right" type="submit" value="Отправить" />-->
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <ProductOrders :loading="loadingProduct" :rowsOrder="rowsOrder"  @addReceipt="addReceipt" @changeVal="changeVal" @deleteChange="deleteChange" @download="download" @downloadAll="downloadAll" @uploadImage="uploadImageOrder"></ProductOrders>
        <ReceiptOrders :loading="loadingProduct" :rowsReceipt="rowsReceipt" @changeVal="changeVal" @downloadAllReceipt="downloadAllReceipt" @uploadImageReceipt="uploadImageReceipt" @downloadPdfReceipt="downloadPdfReceipt"></ReceiptOrders>
    </div>
</template>

<script>
    import Filters from '../../../components/Filters.vue'
    import RemnantsOrders from './Remnants'
    import ProductOrders from './Orders'
    import ReceiptOrders from './Receipt'
    import { filter, map } from 'lodash'
    import DatePicker from 'vuejs-datepicker'
    import API from '../../../api/API'
    import Storage from '../../../api/Storage'
    import Helper from '../../../api/Helper'
    import TypeColor from '../../../assets/TypeColor'
    import ProductTabs from './ProductTabs.vue'
    import StatisticTable from '../../../components/StatisticTable.vue'
    import moment from 'moment'
    import MultiSelect from 'vue-multiselect'
    import { modal } from 'vue-strap'
    import Pdf from 'pdfmake/build/pdfmake.min'
    import pdfFonts from 'pdfmake/build/vfs_fonts'

export default {
  name: 'Product',
  components: {
        Filters,
        RemnantsOrders,
        ProductTabs,
        ProductOrders,
        ReceiptOrders,
        DatePicker,
        moment,
        StatisticTable,
        MultiSelect,
        modal
  },
  data () {
        return {
          offers: [],
          filtersScope: {
            dateFilterCreated: true,
            dateFilterReceipt: true
          },
          loadingRemnants: false,
          isBlock: false,
          Storage: Storage,
          TypeColor: TypeColor,
          Helper: Helper,
          orders: [],
          receipt: [],
          country: null,
          rowRemnants: [],
          footColumns: {},
          form: {
            product: null,
            orders_count: null,
            price: null,
            provider: null,
            delivery_time: Date.now(),
            status: null,
            comment: null,
            country: null
          },
          expiration: Date.now(),
          errors: [],
          errorsByOrder: [],
          storageGoodsAll: null,
          customs: null,
          logistics: null,
          idoffer: null,
          confirmModal: false,
          isLoad: false,
          loadingProduct: false,
          headColumns: [
            {label: this.$root.$t('statistic.product'), field: 'product_id'},
            {label: this.$root.$t('statistic.ordered'), field: 'orders_count'},
            {label: this.$root.$t('statistic.price'), field: 'price'},
            {label: this.$root.$t('statistic.provider'), field: 'provider'},
            {label: this.$root.$t('statistic.time'), field: 'delivery_time'},
            {label: this.$root.$t('statistic.status'), field: 'status'},
            {label: this.$root.$t('statistic.comment'), field: 'comment'}
          ],
          rows: [],
          rowsOrder: [],
          rowsReceipt: [],
          info: []
        }
  },
  mounted () {
        this.getCountries()
        this.getOrders()
        this.getGoods()
        this.getRemnands()
        this.$root.$on('filters_load_new_data', () => {
          this.getOrders()
          this.getGoods()
          this.getRemnands()
        })
  },
  methods: {
        getOrders () {
          this.rowsOrder = []
          this.rowsReceipt = []
          this.loadingProduct = true
          API.getRemnantsOrdersReceipt().then(response => {
            if (response.status === 200) {
              this.loadingProduct = false
              this.rowsOrder = filter(response.body, function (o) { return o.is_receipt === 0 })
              this.rowsReceipt = filter(response.body, function (o) { return o.is_receipt === 1 })
            }
          }).catch(response => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        clickAdd () {
          this.isBlock = !this.isBlock
        },
        checkForm: function (order) {
          this.$emit('update')
          this.errors = []
          if (!this.form.product) {
            this.errors.push('Укажите продукт')
          }
          if (!this.form.orders_count) {
            this.errors.push('Укажите Количество заказов')
          }
          if (!this.form.price) {
            this.errors.push('Укажите цену')
          }
          if (!this.form.provider) {
            this.errors.push('Укажите Постовщика')
          }
          if (!this.form.status) {
            this.errors.push('Укажите Статус')
          }
          if (Storage.selectedCountry.id === -1) {
            if (!this.form.country) {
              this.errors.push('Укажите Страну')
            }
          }
          if (!this.errors.length) {
            this.isLoading = true
            let formData = new FormData()
            if (Storage.selectedCountry.id === -1) {
              for (let key in this.form) {
                if (key !== 'country') {
                  formData.append(key, this.form[key])
                }
              }
              formData.append('delivery_time', moment(this.form.delivery_time).format('Y-MM-DD'))
              formData.append('file', this.files)
              formData.append('country_id', this.form.country)
              formData.append('product_id', this.form.product.alias)
            } else {
              for (let key in this.form) {
                formData.append(key, this.form[key])
              }
              formData.append('delivery_time', moment(this.form.delivery_time).format('Y-MM-DD'))
              formData.append('file', this.files)
              formData.append('country_id', Storage.selectedCountry.id)
              formData.append('product_id', this.form.product.alias)
            }
            API.postRemnandsNew(formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then((res) => {
                if (res.body === true) {
                  console.log(formData, 'formdata')
                  this.isLoading = false
                  this.isBlock = false
                  this.getOrders()
                  this.getRemnands()
                }
              }).catch(response => {
                this.isLoading = false
                this.$root.$emit('data_loaded')
                this.$notify({
                  type: 'danger',
                  title: this.$root.$t('verbs.error'),
                  text: !response.body.message ? response.body : response.body.message,
                  animationType: 'velocity'
                })
              })
            this.form.product = null
            this.form.orders_count = null
            this.form.price = null
            this.form.provider = null
            this.form.delivery_time = Date.now()
            this.form.status = null
            this.form.comment = null
          }
          order.preventDefault()
        },
        getRemnands () {
          this.rowRemnants = []
          this.loadingRemnants = true
          API.getRemnands().then(response => {
            if (response.status === 200) {
              this.loadingRemnants = false
              this.rowRemnants = response.body
            }
          }).catch(response => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        getGoods () {
          API.getGoods(Helper.getCountryList())
            .then((res) => {
              Storage.goods = res.body
            }).catch(response => {
              this.isLoading = false
              this.$root.$emit('data_loaded')
              this.$notify({
                type: 'danger',
                title: this.$root.$t('verbs.error'),
                text: !response.body.message ? response.body : response.body.message,
                animationType: 'velocity'
              })
            })
        },
        getGoodsAll () {
          API.getGoods(this.form.country)
            .then((res) => {
              this.storageGoodsAll = res.body
            }).catch(response => {
              this.isLoading = false
              this.$root.$emit('data_loaded')
              this.$notify({
                type: 'danger',
                title: this.$root.$t('verbs.error'),
                text: !response.body.message ? response.body : response.body.message,
                animationType: 'velocity'
              })
            })
        },
        changeValRemnants (obj) {
          API.putEditRemains(obj).then(response => {
            this.getOrders()
            this.getRemnands()
          })
          .catch(response => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        changeVal (obj) {
          API.putEditOrder(obj).then(response => {
            this.getOrders()
            this.getRemnands()
          })
          .catch(response => {
            this.$root.$emit('data_loaded')
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        deleteChange (id) {
          API.deleteOrder(id).then(response => {
            this.getOrders()
          })
          .catch(response => {
            this.$root.$emit('data_loaded')
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        addReceipt (idOffer) {
          this.confirmModal = true
          this.idoffer = idOffer
        },
        addExpiration () {
          this.$emit('update')
          this.errorsByOrder = []
          if (!this.errorsByOrder.length) {
            this.isLoading = true
            let date = moment(this.expiration).format('YYYY-MM-DD')
            let obj = {
              is_receipt: 1,
              expiration_date: date,
              logistic: this.logistics,
              customs: this.customs
            }
            API.postEditOrder(this.idoffer, obj).then(response => {
              this.getOrders()
              this.getRemnands()
              this.confirmModal = false
              this.logistics = null
              this.customs = null
              this.errorsByOrder = []
            })
                .catch(response => {
                  this.$root.$emit('data_loaded')
                  this.$notify({
                    type: 'danger',
                    title: this.$root.$t('verbs.error'),
                    text: !response.body.message ? response.body : response.body.message,
                    animationType: 'velocity'
                  })
                })
          }
        },
        download (idOffer) {
          API.getRemnantsOrdersReceipt()
            .then(response => {
              Storage.info = response.body
              let bb = {}
              this.info = filter(Storage.info, function (o) {
                return o.id === idOffer
              })
              for (let i in this.info) {
                console.log(i, this.info[i], 'инфо1')
                bb = this.info[i]
              }
              console.log(bb, 'log1')

              function toDataURL (url, callback) {
                var xhr = new XMLHttpRequest()
                xhr.onload = function () {
                  var reader = new FileReader()
                  reader.onloadend = function () {
                    callback(reader.result)
                  }
                  reader.readAsDataURL(xhr.response)
                }
                xhr.open('GET', url)
                xhr.responseType = 'blob'
                xhr.send()
              }

              Pdf.vfs = pdfFonts.pdfMake.vfs
              console.log(bb.product_id, 'product')
              let product = filter(Storage.goods, function (o) {
                return o.alias === bb.product_id
              })
              let productName
              for (let i in product) {
                productName = product[i].name
              }
              if (!bb.image) {
                Pdf.createPdf({
                  content: [
                    {text: 'Ваш заказ', style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20]},
                    {
                      table: {
                        alignment: 'center',
                        widths: [60, 80, 80, 80, 90, 80],
                        margin: [0, 20, 20, 0],
                        body: [
                          [{text: 'Товар', alignment: 'center', bold: true}, {
                            text: 'Количество',
                            alignment: 'center',
                            bold: true
                          }, {text: 'Цена', alignment: 'center', bold: true}, {
                            text: 'Поставщик',
                            alignment: 'center',
                            bold: true
                          }, {text: 'Срок поставки', alignment: 'center', bold: true}, {
                            text: 'Комментарии',
                            alignment: 'center',
                            bold: true
                          }],
                          [{text: productName, alignment: 'center'}, {
                            text: bb.orders_count,
                            alignment: 'center'
                          }, {text: bb.price, alignment: 'center'}, {
                            text: bb.provider,
                            alignment: 'center'
                          }, {text: bb.delivery_time, alignment: 'center'}, {text: bb.comment, alignment: 'center'}]
                        ]
                      }
                    }
                  ]
                }).download('Order.pdf')
              } else {
                toDataURL(`https://api.analytics.leadgroup.su/order_images/${bb.image}`, function (dataUrl) {
                  Pdf.createPdf({
                    content: [
                      {
                        text: 'Ваш заказ',
                        style: 'header',
                        alignment: 'center',
                        fontSize: 25,
                        margin: [0, 10, 0, 20]
                      },
                      {
                        table: {
                          alignment: 'center',
                          widths: [60, 80, 80, 80, 90, 80],
                          margin: [0, 20, 20, 0],
                          body: [
                            [{text: 'Товар', alignment: 'center', bold: true}, {
                              text: 'Количество',
                              alignment: 'center',
                              bold: true
                            }, {text: 'Цена', alignment: 'center', bold: true}, {
                              text: 'Поставщик',
                              alignment: 'center',
                              bold: true
                            }, {text: 'Срок поставки', alignment: 'center', bold: true}, {
                              text: 'Комментарии',
                              alignment: 'center',
                              bold: true
                            }],
                            [{text: productName, alignment: 'center'}, {
                              text: bb.orders_count,
                              alignment: 'center'
                            }, {text: bb.price, alignment: 'center'}, {
                              text: bb.provider,
                              alignment: 'center'
                            }, {text: bb.delivery_time, alignment: 'center'}, {
                              text: bb.comment,
                              alignment: 'center'
                            }]
                          ]
                        }
                      },
                      {text: 'Фото вашего товара', alignment: 'center', fontSize: 25, margin: [0, 20, 0, 20]},
                      {
                        image: `${dataUrl}`,
                        width: 400,
                        alignment: 'center'
                      }
                    ]
                  }).download('Order.pdf')
                })
              }
            })
            .catch(response => {
              this.$notify({
                type: 'danger',
                title: this.$root.$t('verbs.error'),
                text: !response.body.message ? response.body : response.body.message,
                animationType: 'velocity'
              })
            })
        },
        downloadPdfReceipt (idOffer) {
          API.getRemnantsOrdersReceipt()
              .then(response => {
                Storage.info = response.body
                let bb = {}
                this.info = filter(Storage.info, function (o) {
                  return o.id === idOffer
                })
                for (let i in this.info) {
                  console.log(i, this.info[i], 'инфо1')
                  bb = this.info[i]
                }
                console.log(bb, 'log1')

                function toDataURL (url, callback) {
                  var xhr = new XMLHttpRequest()
                  xhr.onload = function () {
                    var reader = new FileReader()
                    reader.onloadend = function () {
                      callback(reader.result)
                    }
                    reader.readAsDataURL(xhr.response)
                  }
                  xhr.open('GET', url)
                  xhr.responseType = 'blob'
                  xhr.send()
                }

                Pdf.vfs = pdfFonts.pdfMake.vfs
                console.log(bb.product_id, 'product')
                let product = filter(Storage.goods, function (o) {
                  return o.alias === bb.product_id
                })
                let productName
                for (let i in product) {
                  productName = product[i].name
                }
                if (!bb.image) {
                  Pdf.createPdf({
                    content: [
                        {text: 'Ваш заказ', style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20]},
                      {
                        table: {
                          alignment: 'center',
                          widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                          margin: [0, 20, 20, 0],
                          body: [
                            [{text: 'Товар', alignment: 'center', bold: true, fontSize: 9}, {
                              text: 'Количество',
                              alignment: 'center',
                              bold: true,
                              fontSize: 9
                            }, {text: 'Цена', alignment: 'center', bold: true, fontSize: 9}, {text: 'Логистика', alignment: 'center', bold: true, fontSize: 9}, {text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9}, {
                              text: 'Поставщик',
                              alignment: 'center',
                              bold: true,
                              fontSize: 9
                            }, {text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9}, {text: 'Долг', alignment: 'center', bold: true, fontSize: 9}, {
                              text: 'Комментарии',
                              alignment: 'center',
                              bold: true,
                              fontSize: 9
                            }],
                            [{text: productName, alignment: 'center', fontSize: 9}, {
                              text: bb.orders_count,
                              alignment: 'center',
                              fontSize: 9
                            }, {text: bb.price, alignment: 'center', fontSize: 9}, {text: bb.logistic, alignment: 'center', fontSize: 9}, {text: bb.customs, alignment: 'center', fontSize: 9}, {
                              text: bb.provider,
                              alignment: 'center',
                              fontSize: 9
                            }, {text: bb.delivery_time, alignment: 'center', fontSize: 9}, {text: (bb.price + bb.logistic + bb.customs) * bb.orders_count, alignment: 'center', fontSize: 9}, {text: bb.comment, alignment: 'center', fontSize: 9}]
                          ]
                        }
                      }
                    ]
                  }).download('Receipt.pdf')
                } else {
                  toDataURL(`https://api.analytics.leadgroup.su/order_images/${bb.image}`, function (dataUrl) {
                    Pdf.createPdf({
                      content: [
                        {
                          text: 'Ваш заказ',
                          style: 'header',
                          alignment: 'center',
                          fontSize: 25,
                          margin: [0, 10, 0, 20]
                        },
                        {
                          table: {
                            alignment: 'center',
                            widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                            margin: [0, 0, 0, 0],
                            body: [
                              [{text: 'Товар', alignment: 'center', bold: true, fontSize: 9}, {
                                text: 'Кол-тво',
                                alignment: 'center',
                                bold: true,
                                fontSize: 9
                              }, {text: 'Цена', alignment: 'center', bold: true, fontSize: 9}, {text: 'Логистика', alignment: 'center', bold: true, fontSize: 9}, {text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9}, {
                                text: 'Поставщик',
                                alignment: 'center',
                                bold: true,
                                fontSize: 9
                              }, {text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9}, {text: 'Долг', alignment: 'center', bold: true, fontSize: 9}, {
                                text: 'Комментарии',
                                alignment: 'center',
                                bold: true,
                                fontSize: 9
                              }],
                              [{text: productName, alignment: 'center', fontSize: 9}, {
                                text: bb.orders_count,
                                alignment: 'center',
                                fontSize: 9
                              }, {text: bb.price, alignment: 'center', fontSize: 9}, {text: bb.logistic, alignment: 'center', fontSize: 9}, {text: bb.customs, alignment: 'center', fontSize: 9}, {
                                text: bb.provider,
                                alignment: 'center',
                                fontSize: 9
                              }, {text: bb.delivery_time, alignment: 'center', fontSize: 9}, {text: (bb.price + bb.logistic + bb.customs) * bb.orders_count, alignment: 'center', fontSize: 9}, {
                                text: bb.comment,
                                alignment: 'center',
                                fontSize: 9
                              }]
                            ]
                          }
                        },
                        {text: 'Фото вашего товара', alignment: 'center', fontSize: 25, margin: [0, 20, 0, 20]},
                        {
                          image: `${dataUrl}`,
                          width: 400,
                          alignment: 'center'
                        }
                      ]
                    }).download('Receipt.pdf')
                  })
                }
              })
              .catch(response => {
                this.$notify({
                  type: 'danger',
                  title: this.$root.$t('verbs.error'),
                  text: !response.body.message ? response.body : response.body.message,
                  animationType: 'velocity'
                })
              })
        },
        uploadImageOrder (idOrder, files, name) {
          let formData = new FormData()
          formData.append('file', name[0])
          API.postEditOrder(idOrder, formData).then(response => {
            this.getOrders()
            this.getRemnands()
          })
            .catch(response => {
              this.$root.$emit('data_loaded')
              this.$notify({
                type: 'danger',
                title: this.$root.$t('verbs.error'),
                text: !response.body.message ? response.body : response.body.message,
                animationType: 'velocity'
              })
            })
        },
        uploadImageReceipt (idOrder, files, name) {
          let formData = new FormData()
          formData.append('file', name[0])
          API.postEditOrder(idOrder, formData).then(response => {
            this.getOrders()
            this.getRemnands()
          })
              .catch(response => {
                this.$root.$emit('data_loaded')
                this.$notify({
                  type: 'danger',
                  title: this.$root.$t('verbs.error'),
                  text: !response.body.message ? response.body : response.body.message,
                  animationType: 'velocity'
                })
              })
        },
        downloadAll () {
          console.log('downloadAll')
          Pdf.vfs = pdfFonts.pdfMake.vfs
          let pdfAllOrder = []
          map(Object.values(this.rowsOrder), function (i) {
            return filter(Storage.goods, function (o) {
              if (Storage.selectedCountry.id === -1) {
                if (o.alias === i.product_id && o.country_id === i.country_id) {
                  pdfAllOrder.push({
                    name: o.name,
                    id: i.product_id,
                    comment: i.comment,
                    orders_count: i.orders_count,
                    provider: i.provider,
                    price: i.price,
                    time: i.delivery_time
                  })
                }
              } else {
                if (o.alias === i.product_id) {
                  pdfAllOrder.push({
                    name: o.name,
                    id: i.product_id,
                    comment: i.comment,
                    orders_count: i.orders_count,
                    provider: i.provider,
                    price: i.price,
                    time: i.delivery_time
                  })
                }
              }
            })
          }
          )
          console.log(pdfAllOrder, 'pdfAllOrder')
          Pdf.createPdf({
            content: map(pdfAllOrder, function (i, index) {
              return [
                {text: `Заказ №${index + 1}`, style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20]},
                {unbreakable: true,
                  stack: [
                    { table: {
                      alignment: 'center',
                      widths: [60, 80, 80, 80, 90, 80],
                      margin: [0, 20, 20, 0],
                      body: [
                        [{text: 'Товар', alignment: 'center', bold: true}, {
                          text: 'Количество',
                          alignment: 'center',
                          bold: true
                        }, {text: 'Цена', alignment: 'center', bold: true}, {
                          text: 'Поставщик',
                          alignment: 'center',
                          bold: true
                        }, {text: 'Срок поставки', alignment: 'center', bold: true}, {
                          text: 'Комментарии',
                          alignment: 'center',
                          bold: true
                        }]
                      ]
                    }
                    }
                  ]
                },
                {unbreakable: true,
                  stack: [
                    { table: {
                      alignment: 'center',
                      widths: [60, 80, 80, 80, 90, 80],
                      margin: [0, 20, 20, 0],
                      body:
                      [
                        [{text: i.name, alignment: 'center', style: 'tableAll'},
                            {text: i.orders_count, alignment: 'center', style: 'tableAll'},
                            {text: i.price, alignment: 'center', style: 'tableAll'},
                            {text: i.provider, alignment: 'center', style: 'tableAll'},
                            {text: i.time, alignment: 'center', style: 'tableAll'},
                            {text: i.comment, alignment: 'center', style: 'tableAll'}
                        ]
                      ]
                    }
                    }
                  ]
                }
              ]
            })
          }).download('Orders.pdf')
        },
        downloadAllReceipt () {
          Pdf.vfs = pdfFonts.pdfMake.vfs
          let pdfAllOrder = []
          map(Object.values(this.rowsReceipt), function (i) {
            return filter(Storage.goods, function (o) {
              if (Storage.selectedCountry.id === -1) {
                if (o.alias === i.product_id && o.country_id === i.country_id) {
                  let credit = (i.price + i.logistic + i.customs) * i.orders_count
                  pdfAllOrder.push({
                    name: o.name,
                    id: i.product_id,
                    comment: i.comment,
                    logistic: i.logistic,
                    customs: i.customs,
                    credit: credit,
                    orders_count: i.orders_count,
                    provider: i.provider,
                    price: i.price,
                    time: i.delivery_time
                  })
                }
              } else {
                if (o.alias === i.product_id) {
                  let credit = (i.price + i.logistic + i.customs) * i.orders_count
                  pdfAllOrder.push({
                    name: o.name,
                    id: i.product_id,
                    comment: i.comment,
                    logistic: i.logistic,
                    customs: i.customs,
                    credit: credit,
                    orders_count: i.orders_count,
                    provider: i.provider,
                    price: i.price,
                    time: i.delivery_time
                  })
                }
              }
            })
          }
          )
          console.log(pdfAllOrder, 'pdfAllOrder')
          Pdf.createPdf({
            content: map(pdfAllOrder, function (i, index) {
              return [
                {text: `Заказ №${index + 1}`, style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20]},
                {unbreakable: true,
                  stack: [
                    { table: {
                      alignment: 'center',
                      widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                      margin: [0, 0, 0, 0],
                      body: [
                        [{text: 'Товар', alignment: 'center', bold: true, fontSize: 9}, {
                          text: 'Количество',
                          alignment: 'center',
                          bold: true,
                          fontSize: 9
                        }, {text: 'Цена', alignment: 'center', bold: true, fontSize: 9}, {text: 'Логистика', alignment: 'center', bold: true, fontSize: 9}, {text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9}, {
                          text: 'Поставщик',
                          alignment: 'center',
                          bold: true,
                          fontSize: 9
                        }, {text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9}, {text: 'Долг', alignment: 'center', bold: true, fontSize: 9}, {
                          text: 'Комментарии',
                          alignment: 'center',
                          bold: true,
                          fontSize: 9
                        }]
                      ]
                    }
                    }
                  ]
                },
                {unbreakable: true,
                  stack: [
                    { table: {
                      alignment: 'center',
                      widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                      margin: [0, 0, 0, 0],
                      body:
                      [
                        [{text: i.name, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.orders_count, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.price, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.logistic, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.customs, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.provider, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.time, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.credit, alignment: 'center', style: 'tableAll', fontSize: 9},
                            {text: i.comment, alignment: 'center', style: 'tableAll', fontSize: 9}
                        ]
                      ]
                    }
                    }
                  ]
                }
              ]
            })
          }).download('Receipts.pdf')
        },
        handleFilesUpload (fileName, file) {
          this.files = file[0]
        },
        getCountries () {
          API.getCountries()
            .then(res => {
              Storage.countries = res.body
              console.log(Storage.countries, 'country')
            })
            .catch(error => {
              console.log(error)
            })
        }
  }
}
</script>

<style>
    .error {
        color: #a94442;
        background-color: #f2dede;
        border:1px solid #ebccd1;
        padding: 15px;
    }
    .error ul {
        padding-left: 30px;
    }
    .error li {
        padding-top: 5px;
    }
    select.form-controls{
        display: block;
        width: 100%;
        padding: 0.5rem 1rem;
        font-size: 0.875rem;
        line-height: 1.25;
        color: #607d8b;
        background-color: #fff;
        background-image: none;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    }
    .input-group{
        margin-top: 10px;
    }
    .input {
        min-height: 40px;
    }
    .datepicker{
        width: 100%;
    }
    .disabledbutton {
        pointer-events: none;
        opacity: 0.8;
    }
    .card-modal{
      border: none;
      margin: 0;
    }
    .filter-buttons{
      margin-top: 10px;
    }
    .card-modal{
      flex: 1 1 auto;
      padding: 0 1rem;
    }
    .pad-top-btn {
        padding-top: 12px;
    }
</style>



// WEBPACK FOOTER //
// Product.vue?7064f86a